import store from '@/store';
import router from '@/router';
import i18n from '@/i18n';
import api from '../../../api/partnerships';
import * as types from './types';

export default {

  getPartnerships(context, params) {
    store.dispatch('application/startLoading');
    return api.getPartnerships(params)
      .then((response) => {
        store.dispatch('application/finishLoading');
        context.commit(types.GET_PARTNERSHIPS_SUCCESS, response.data.data);
        return response;
      })
      .catch(() => {
        store.dispatch('application/finishLoading');
        context.commit(types.GET_PARTNERSHIPS_FAILURE);
        store.dispatch('application/openSnackbar', {
          message: i18n.t('partnerships.error.message.get.partnerships'),
        });
      });
  },

  getPartnership(context, id) {
    store.dispatch('application/startLoading');
    return api.getPartnership(id)
      .then((response) => {
        store.dispatch('application/finishLoading');
        return response.data.data.ps;
      })
      .catch(() => {
        store.dispatch('application/finishLoading');
        store.dispatch('application/openSnackbar', {
          message: i18n.t('partnerships.error.message.get.partnership.info'),
        });
      });
  },

  updatePartnership(context, partnership) {
    store.dispatch('application/startLoading');
    return api.updatePartnership(partnership)
      .then((data) => {
        store.dispatch('application/finishLoading');
        store.dispatch('application/openSnackbar', {
          message: i18n.t('partnerships.success.message.partnership.update'),
        });
        return data;
      })
      .catch((error) => {
        store.dispatch('application/finishLoading');
        console.log(error);
        store.dispatch('application/openSnackbar', {
          message: i18n.t('partnerships.error.message.partnership.update'),
        });
      });
  },

  updatePartnershipTransmissionMode(context, partnership) {
    store.dispatch('application/startLoading');
    return api.updatePartnershipTransmissionMode(partnership)
      .then((data) => {
        store.dispatch('application/finishLoading');
        store.dispatch('application/openSnackbar', {
          message: i18n.t('partnerships.success.message.partnership.update'),
        });
        return data;
      })
      .catch((error) => {
        store.dispatch('application/finishLoading');
        console.log(error);
        store.dispatch('application/openSnackbar', {
          message: i18n.t('partnerships.error.message.partnership.update'),
        });
      });
  },

  addPartnership(context, params) {
    store.dispatch('application/startLoading');
    return api.addPartnership(params)
      .then((data) => {
        store.dispatch('application/finishLoading');
        store.dispatch('application/openSnackbar', {
          message: i18n.t('partnerships.success.message.partnership.create'),
        });
        return data;
      })
      .catch((error) => {
        store.dispatch('application/finishLoading');
        console.log(error);
        const isSiretUnknown = error.response.data &&
          error.response.data.data &&
          error.response.data.data.errors &&
          error.response.data.data.errors[0].includes('Impossible de récupérer les informations pour créer l\'organisation avec le SIRET');
        if (isSiretUnknown) {
          store.dispatch('application/openSnackbar', {
            message: i18n.t('partnerships.error.message.partnership.create.siret'),
          });
        } else {
          store.dispatch('application/openSnackbar', {
            message: i18n.t('partnerships.error.message.partnership.create'),
          });
        }
        return Promise.reject(error);
      });
  },

  getPartnershipsGroups(context, params) {
    store.dispatch('application/startLoading');
    return api.getPartnershipsGroups(params)
      .then((data) => {
        store.dispatch('application/finishLoading');
        context.commit(types.UPDATE_PARTNERS_GROUPS, data.data.data);
        return data;
      })
      .catch((error) => {
        store.dispatch('application/finishLoading');
        console.log(error);
        store.dispatch('application/openSnackbar', {
          message: i18n.t('partnerships.error.message.get.partnerships.groups'),
        });
      });
  },

  disablePartnership(context, id) {
    store.dispatch('application/startLoading');
    return api.disablePartnership(id)
      .then((data) => {
        store.dispatch('application/finishLoading');
        store.dispatch('application/openSnackbar', {
          message: i18n.t('partnerships.success.message.partnership.desactivated'),
        });
        return data;
      })
      .catch((error) => {
        store.dispatch('application/finishLoading');
        console.log(error);
        store.dispatch('application/openSnackbar', {
          message: i18n.t('partnerships.error.message.partnership.desactivated'),
        });
        return Promise.reject(error);
      });
  },


  finalizePartnership(context, params) {
    store.dispatch('application/startLoading');
    return api.finalizePartnership(params)
      .then((data) => {
        store.dispatch('application/finishLoading');
        store.dispatch('application/openSnackbar', {
          message: i18n.t('partnerships.success.message.partnership.finalized'),
        });
        return data;
      })
      .catch((error) => {
        store.dispatch('application/finishLoading');
        console.log(error);
        store.dispatch('application/openSnackbar', {
          message: i18n.t('partnerships.error.message.partnership.finalized'),
        });
      });
  },

  getUnvalidatedPartnerships(context, params) {
    store.dispatch('application/startLoading');
    return api.getUnvalidatedPartnerships(params)
      .then((data) => {
        store.dispatch('application/finishLoading');
        context.commit(types.GET_PARTNERSHIPS_SUCCESS, data.data.data);
        return data;
      })
      .catch((error) => {
        store.dispatch('application/finishLoading');
        console.log(error);
        store.dispatch('application/openSnackbar', {
          message: i18n.t('partnerships.error.message.get.not.validated.partnerships'),
        });
      });
  },

  enablePartnership(context, id) {
    store.dispatch('application/startLoading');
    return api.enablePartnership(id)
      .then((data) => {
        store.dispatch('application/finishLoading');
        store.dispatch('application/openSnackbar', {
          message: i18n.t('partnerships.success.message.partnership.activated'),
        });
        return data;
      })
      .catch((error) => {
        store.dispatch('application/finishLoading');
        console.log(error);
        store.dispatch('application/openSnackbar', {
          message: i18n.t('partnerships.error.message.partnership.activated'),
        });
        return Promise.reject(error);
      });
  },

  breadcrumbSlice(context, params) {
    context.commit(types.BREADCRUMB_SLICE, params);
  },

  updateCurrentGroup(context, object) {
    context.commit(types.BREADCRUMB_UPDATE_CURRENT_GROUP, object);
  },

  breadcrumbPush(context, object) {
    context.commit(types.BREADCRUMB_PUSH, object);
  },

  setBreadcrumbs(context, array) {
    context.commit(types.SET_BREADCRUMBS, array);
  },

  updateAsideElmts(context, array) {
    context.commit(types.UPDATE_ASIDE_ELMTS, array);
  },

  updateViewCard(context, boolean) {
    context.commit(types.UPDATE_VIEW_CARD, boolean);
  },

  createPartnershipsGroup(context, params) {
    store.dispatch('application/startLoading');
    api.createPartnershipsGroup(params)
      .then((data) => {
        store.dispatch('application/finishLoading');
        router.push({ name: 'PartnershipGroups' });
        store.dispatch('application/openSnackbar', {
          message: i18n.t('partnerships.success.message.create.partnership.group'),
        });
        return data;
      })
      .catch((error) => {
        store.dispatch('application/finishLoading');
        router.push({ name: 'PartnershipGroups' });
        console.log(error);
        store.dispatch('application/openSnackbar', {
          message: i18n.t('partnerships.error.message.create.partnership.group'),
        });
      });
  },

  deleteThirdPartyGroup(context, id) {
    store.dispatch('application/startLoading');
    api.deleteThirdPartyGroup(id)
      .then((data) => {
        store.dispatch('application/openSnackbar', {
          message: i18n.t('partnerships.success.message.delete.partnership.group'),
        });
        router.push({ name: 'PartnershipGroups' });
        return data;
      })
      .catch((error) => {
        console.log(error);
        store.dispatch('application/openSnackbar', {
          message: i18n.t('partnerships.error.message.delete.partnership.group'),
        });
      })
      .finally(() => {
        store.dispatch('application/finishLoading');
      });
  },

  getPartnershipGroup(context, id) {
    store.dispatch('application/startLoading');
    return api.getPartnershipGroup(id)
      .then((data) => {
        store.dispatch('application/finishLoading');
        return data.data.data;
      })
      .catch((error) => {
        store.dispatch('application/finishLoading');
        console.log(error);
        store.dispatch('application/openSnackbar', {
          message: i18n.t('partnerships.error.message.get.partnership.group.info'),
        });
      });
  },

  updateThirdPartyGroup(context, group) {
    store.dispatch('application/startLoading');
    api.updateThirdPartyGroup(group)
      .then((data) => {
        store.dispatch('application/finishLoading');
        router.push({ name: 'PartnershipGroups' });
        store.dispatch('application/openSnackbar', {
          message: i18n.t('partnerships.success.message.update.partnership.group'),
        });
        return data;
      })
      .catch((error) => {
        store.dispatch('application/finishLoading');
        router.push({ name: 'PartnershipGroups' });
        console.log(error);
        store.dispatch('application/openSnackbar', {
          message: i18n.t('partnerships.error.message.update.partnership.group'),
        });
      });
  },

  validateThirdPartyMail(context, params) {
    store.dispatch('application/startLoading');
    return api.validateThirdPartyMail(params)
      .then((data) => {
        store.dispatch('application/finishLoading');
        store.dispatch('application/openSnackbar', {
          message: i18n.t('partnerships.success.message.validated.user'),
        });
        return data;
      })
      .catch((error) => {
        store.dispatch('application/finishLoading');
        store.dispatch('application/openSnackbar', {
          message: i18n.t('partnerships.error.message.validated.user'),
        });
        console.log(error);
      });
  },

};



// WEBPACK FOOTER //
// ./src/store/modules/partnerships/actions.js